import pinia from "@/plugins/pinia";
import { useMenuStateStore } from "@/store/menu-state";
import { useRequestDataStore } from "@/store/request-data";
import { BaseMenuEntry } from "./base-menu-entry";

export class TargetsMenuEntry extends BaseMenuEntry
{
    protected requestDataStore = useRequestDataStore(pinia);
    protected menuStateStore = useMenuStateStore(pinia);

    public getPicto() : string
    {
        return require("@/assets/pictos/menu-entries/06-targets.svg");
    }

    public isEnabled() : boolean
    {
        return this.requestDataStore.isDrugModelSelected;
    }

    public isValid() : boolean
    {
        // Valid when there is at least a single target
        return this.requestDataStore.hasTargets;
    }

    public isValidated() : boolean
    {
        // Validated by user. To comply with the GUI spec, this store variable should be
        // set to true when the user adds a custom target.
        return this.menuStateStore.targetsValidated;
    }

    public toggleValidation() : void
    {
        this.menuStateStore.targetsValidated = !this.menuStateStore.targetsValidated;
    }
}
